export default __webpack_public_path__ + "static/media/airtime2cash.2f1d5bc4.svg";